<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Contact Info'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper>


      @if (loaded) {
        @if (showCompanyName) {
          <tidy-row>
            <tidy-input
              formControlName="companyName"
              [form]="form.controls.companyName"
              [label]="'Company Name'"
              [submitted]="submitted"
              [icon]="'assets/svg/information-circle.svg'" />
          </tidy-row>
        }
        <tidy-row>
          <tidy-input
            formControlName="firstName"
            [form]="form.controls.firstName"
            [label]="'First Name'"
            [errorMessage]="'Please enter your first name.'"
            [submitted]="submitted"
            [icon]="'assets/svg/person.svg'" />
        </tidy-row>
        <tidy-row>
          <tidy-input
            formControlName="lastName"
            [form]="form.controls.lastName"
            [label]="'Last Name'"
            [errorMessage]="'Please enter your last name.'"
            [submitted]="submitted"
            [icon]="'assets/svg/person.svg'" />
        </tidy-row>
        <tidy-row>
          <tidy-input
            formControlName="email"
            [label]="'Email'"
            [form]="form.controls.email"
            type="email"
            [submitted]="submitted"
            [errorMessage]="'Please enter a valid email.'"
            [icon]="'assets/svg/mail.svg'" />
        </tidy-row>
        <tidy-row>
          <tidy-input
            formControlName="billEmail"
            [label]="'Email to send bills to'"
            [form]="form.controls.billEmail"
            type="email"
            [submitted]="submitted"
            [errorMessage]="'Please enter a valid email.'"
            [icon]="'assets/svg/mail.svg'" />
        </tidy-row>
        <tidy-row>
          <tidy-input-international-phone
            formControlName="phone"
            [label]="'Phone'"
            [form]="form.controls.phone"
            [inputMode]="'numeric'"
            [submitted]="submitted"
            [errorMessage]="'Please enter a valid phone.'"
            [icon]="'assets/svg/phone-portrait.svg'"
            [initialMask]="{ mask: '[00000000000000000000000]' }"
            (countryCodeChange)="onCountryCodeChange($event)" />
        </tidy-row>
        <tidy-button
          [text]="'Save Changes'"
          [action]="boundSave"
          class="primary" />
        <tidy-error-message [text]="errorMessage" />
      }

    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
